import type { TranslationFunction, Translations } from "@/translations";
import type { ApiQueryParams } from "@/types/api-types";

type UserStatuses = ApiQueryParams<"getUsersV1">["Statuses"];
export type UserStatus = (typeof USER_STATUSES)[number];

export const getUserStatusLabelByType = (
  t: TranslationFunction<Translations>,
  type: (typeof USER_STATUSES)[number],
): string => {
  switch (type) {
    case "onboarded":
      return t("common.label.user-status.onboarded");
    case "invited":
      return t("common.label.user-status.invited");
    case "deleted":
      return t("common.label.user-status.deleted");
    default:
      console.error(`Unknown user status "${type}"`);

      return "";
  }
};

export const USER_STATUSES = ["onboarded", "invited", "deleted"] as const satisfies UserStatuses;
